/**
 * @file 支払い済み共済金合計を算出する際のフォームごとのイベントセット
 */
'use strict'

/**
 * @classname CalculatePaidMutualAid
 * @classdesc 支払い済み共済金合計を算出する際のフォームごとのイベントセット
 */
 export default class CalculatePaidMutualAid {
	/**
	 * @constructor
	 * @param {jQuery} $e - $('.paid_mutual_aid_price')
	 */
	constructor($e, controller) {
		console.log('CalculatePaidMutualAid.constructor')
		this._$e = $e
		this._controller = controller
		this._$e.on('change', () => this.trigger())
	}


	/**
	 * 'change' のコールバック
	 *
	 * @memberof CalculatePaidMutualAid
	 * @return {undefined}
	 */
	trigger() {
		console.log('CalculatePaidMutualAid.trigger')
		this._controller._listener.trigger('total-paid-mutual-aid-calculate')
	}
}
